import { getAuth } from "@firebase/auth"
import "firebase/auth"
import { initializeApp } from "@firebase/app"
import { getFirestore } from "@firebase/firestore"
const firebaseconfig = {
  apiKey: "AIzaSyDFwYo_ijCdlYCP-YSQt83LxaSyV5t-Im8",
  authDomain: "leadtub-webbportal-app-v2.firebaseapp.com",
  projectId: "leadtub-webbportal-app-v2",
  storageBucket: "leadtub-webbportal-app-v2.appspot.com",
  messagingSenderId: "440448565169",
  appId: "1:440448565169:web:b3b4920db3a1d4d5dd0790",
  measurementId: "G-RRJ1QY2X8H"
}
export const app = initializeApp(firebaseconfig)

export const auth = getAuth(app)
export const db = getFirestore(app)

